import { Component, ElementRef, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { Page, Space } from 'app/interfaces/api/types';
import { PageService, SpaceService } from 'app/services';
import { DomHelper } from 'app/classes/dom-helper/dom-helper';
import { MenuController } from '@ionic/angular';
import { Router } from '@angular/router';

@Component({
  selector: 'app-home',
  templateUrl: 'home.page.html',
  styleUrls: ['home.page.scss'],
  encapsulation: ViewEncapsulation.None,
})

export class HomePage implements OnInit {
  @ViewChild('content', { read: ElementRef, static: false })
  private content: ElementRef;

  public page: Page;
  public spaces: Space[] = [];

  public didLoad: boolean = false;

  constructor(
    private readonly pageService: PageService,
    private readonly spaceService: SpaceService,
    private readonly menuController: MenuController,
    private readonly router: Router,
  ) {}

  ngOnInit(): void { }

  ionViewWillEnter(): void {
    this.menuController.enable(true);

    this.reset();
  }

  async ionViewDidEnter(): Promise<void> {
    this.page = await this.pageService.getHomepage();
    this.spaces = await this.spaceService.getAll();

    DomHelper.whenReady(this.content.nativeElement).then(() => this.didLoad = true);
  }

  public openSpace(space: Space): void {
    this.router.navigateByUrl(`/space/${space.slug}`);
  }

  private reset(): void {
    this.didLoad = false;
    this.page = null;
    this.spaces = [];
  }
}
